<template>
    <div v-if="issueLoaded" class="h-screen w-screen overflow-y-hidden absolute top-0 left-0 bg-black">
        <video class="opacity-60 min-h-full w-100vw xl:w-screen object-contain absolute" :src="`${publicPath}static/video/fa${this.currentIssue.slug.slice(-2)}/fa${this.currentIssue.slug.slice(-2)}_bg.mp4`" autoplay loop muted>
            <source :src="`${publicPath}static/video/fa${this.currentIssue.slug.slice(-2)}/fa${this.currentIssue.slug.slice(-2)}_bg.mp4`" type="video/mp4" />
            <source s:src="`${publicPath}static/video/fa${this.currentIssue.slug.slice(-2)}/fa${this.currentIssue.slug.slice(-2)}_bg.webm`" type="video/webm" />
            <img :src="`${publicPath}static/video/fa${this.currentIssue.slug.slice(-2)}/fa${this.currentIssue.slug.slice(-2)}_bg.jpg`" />
        </video>
        <h1 class="relative top-[10rem] lg:absolute lg:w-1/2 lg:top-1/2 lg:left-1/2 lg:-translate-x-1/2 lg:-translate-y-full text-center mx-auto my-auto z-10 text-4xl lg:text-8xl text-offwhite font-serif font-bold">
            {{ this.currentIssue.title }}
        </h1>
        <div class="bg-offwhite h-full mt-72 lg:mt-0 lg:h-36 lg:bottom-0 left-0 absolute w-screen flex flex-col lg:flex-row justify-start lg:justify-between p-4">
            <div>
                <h2 class="font-light uppercase">Artigos</h2>
                <ul class="flex flex-col lg:flex-row">
                    <li class="pr-4" v-for="post in currentIssue.posts" :key="post.postSlug">
                        <router-link
                            class="leading-10 lg:leading-6 mr-0 lg:mr-12"
                            v-if="post.author != null"
                            :to="{
                                name: 'SinglePostView',
                                params: {
                                    issue: currentIssue.slug,
                                    slug: post.postSlug,
                                    componentName: post.comp,
                                    author: post.author,
                                },
                            }"
                        >
                            <p class="text-2xl font-serif font-bold">{{ post.postTitle }}</p>
                            <p class="text-lg">{{ post.author }}</p>
                        </router-link>
                    </li>
                </ul>
            </div>
            <div>
                <h2 class="font-light uppercase mt-8 lg:mt-0">Reportagens</h2>
                <ul class="flex flex-col lg:flex-row">
                    <li v-for="post in currentIssue.posts" :key="post.postSlug" class="text-2xl font-serif font-bold">
                        <router-link
                            class="leading-10 lg:leading-6 mr-0 lg:mr-12"
                            v-if="post.author == null"
                            :to="{
                                name: 'SinglePostView',
                                params: {
                                    issue: currentIssue.slug,
                                    slug: post.postSlug,
                                    componentName: post.comp,
                                    author: post.author,
                                },
                            }"
                        >
                            {{ post.postTitle }}
                        </router-link>
                    </li>
                </ul>
            </div>
            <a target="_blank" :href="`${publicPath}static/pdf/Fapesp60_fasciculo${this.currentIssue.slug.slice(-2)}.pdf`">
                <img class="mt-8 h-14 w-auto opacity-80" :src="require(`@/assets/img/pdf-icon.svg`)" :alt="`Baixar PDF do fascículo`" />
            </a>
        </div>
    </div>

    <div v-else></div>
</template>

<script>
// import PostImage from '@/components/PostImage.vue'

export default {
    // components: { PostImage },
    props: ['slug', 'issueData'],
    data() {
        return {
            header_negative: true,
            publicPath: process.env.BASE_URL,
            issueLoaded: false,
            currentIssue: null,
        }
    },
    mounted() {
        if (this.$route.name == 'SingleIssueView') {
            this.renderIssue()
        }
    },
    watch: {
        $route: function (to, from) {
            if (this.$route.name == 'SingleIssueView') {
                this.renderIssue()
            }
        },
    },
    methods: {
        renderIssue() {
            let currentIssueSlug = this.$route.params.slug
            let currentIssueObj = this.$attrs.issues.filter((e) => e.slug === currentIssueSlug)
            this.currentIssue = currentIssueObj[0]
            this.issueLoaded = true
        },
    },
}
</script>

<style lang="postcss" scoped>
video {
    transform: translate(0, -10%);
    max-width: 150%;
}
li:last-of-type a {
    @apply mr-0;
}
</style>
